module.exports = [
  ['1'], ['2'], ['3'], ['break'],
  ['4'], ['5'], ['6'], ['break'],
  ['7'], ['8'], ['9'], ['break'],
  [{ label: '0', width: 'wide' }], ['del']
]
